import Helper from '@ember/component/helper';
import { task } from 'ember-concurrency';
import { service } from '@ember/service';

export default class PlaybackHelper extends Helper {
  @service stereo;
  @service feeds;

  playbackAiring = task(async () => {
    let sound = this.stereo.findSound(this.airing.playbackUrl);
    if (this.time) {
      await this.feeds.playFeedTask.perform(this.airing, this.time);
    } else if (sound && sound.isPlaying && !this.restart) {
      sound.pause();
    } else {
      await this.feeds.playFeedTask.perform(this.airing);
    }
  });

  compute([airing], options = {}) {
    this.airing = airing;
    let { restart, time } = options;
    this.restart = restart;
    this.time = time;

    return this.playbackAiring;
  }
}
